import { Autocomplete, TextField } from "@mui/material";
import _ from "lodash";
import React from "react";
import { FilterProps } from "react-table";

export type SelectOption = { value: any; label: string };
export type SelectFilterProps = FilterProps<any> & {
  options: SelectOption[];
  loading?: boolean;
  placeholder?: string;
  /** Max height in px for the dropdown listbox; enables scrolling when options exceed height */
  listboxMaxHeight?: number;
};

export function SelectFilter({
  column: { id, filterValue, setFilter, Header },
  loading = false,
  options = [],
  placeholder,
  listboxMaxHeight = 300,
}: SelectFilterProps) {
  const selectedOption = options.find((o) => o.value == filterValue);

  return (
    <Autocomplete
      id={`${id}-filter`}
      loading={loading}
      options={options}
      sx={{ background: "white" }}
      value={selectedOption ?? null}
      onChange={(e, newValue) => setFilter(newValue?.value)}
      isOptionEqualToValue={_.isEqual}
      ListboxProps={{
        style: { maxHeight: listboxMaxHeight },
      }}
      renderInput={(params) => (
        <TextField {...params} placeholder={placeholder || `${Header}`} size="small" />
      )}
    />
  );
}
